/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import * as UsersApi from 'ContentEditorUI/api/UsersApi';
import I18n from 'I18n';
import text from 'I18n/utils/unescapedText';
import formatName from 'I18n/utils/formatName';
const UNPUBLISHED_CHANGES_ALERT_TIMEOUT = 15000;
export default class ShowUnpublishedChangesOnStartup extends Component {
  componentDidMount() {
    this.handleUnpublishedChanges();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.hasUnpublishedChanges !== this.props.hasUnpublishedChanges) {
      this.handleUnpublishedChanges();
    }
  }
  handleUnpublishedChanges() {
    const {
      contentNounKey,
      hasUnpublishedChanges,
      updatedAt,
      updatedById
    } = this.props;
    if (hasUnpublishedChanges) {
      UsersApi.fetch().then(users => {
        const user = users.find(u => u.id === updatedById);
        const translationOptions = {
          lastUpdated: I18n.moment(updatedAt).portalTz().format('L'),
          lastUpdateAuthor: user ? formatName({
            firstName: user.firstName,
            lastName: user.lastName
          }) : I18n.text('app.unknownUser')
        };
        FloatingAlertStore.addAlert({
          message: text(contentNounKey, translationOptions),
          type: 'info',
          timeout: UNPUBLISHED_CHANGES_ALERT_TIMEOUT
        });
      });
    }
  }
  render() {
    return null;
  }
}
ShowUnpublishedChangesOnStartup.propTypes = {
  contentNounKey: PropTypes.string.isRequired,
  hasUnpublishedChanges: PropTypes.bool.isRequired,
  updatedById: PropTypes.number,
  updatedAt: PropTypes.number
};